import { useEffect, useState } from "react";
import {
  FundRecommendationResponse,
  useRecommendApiV1UsersUserIdSingleProductRecommendationsPost,
} from "@rentablo/api/recommender";
import { useMyself } from "@api";
import { useFeatureFlag } from "@hooks";

export const useInvestmentRecommendations = (isin?: string) => {
  const { data: userData } = useMyself();
  const isRecommenderEnabled = useFeatureFlag("RECOMMENDER");
  const { mutateAsync: fetchRecommendations } =
    useRecommendApiV1UsersUserIdSingleProductRecommendationsPost();

  const [recommendations, setRecommendations] = useState<
    FundRecommendationResponse[]
  >([]);

  useEffect(() => {
    if (!isin || !userData?.id || !isRecommenderEnabled) return;
    const fetch = async () => {
      const recommendationsData = await fetchRecommendations({
        userId: userData?.id,
        recommendationRequest: {
          isin,
          n_recommendations: 3,
        },
      });
      setRecommendations(recommendationsData?.recommendations ?? []);
    };
    fetch();
  }, [isin, fetchRecommendations, userData?.id, isRecommenderEnabled]);

  return { recommendations, isRecommenderEnabled };
};
